import React, { useCallback, useEffect, useState } from 'react'
import { useUserAuth } from '../../context/UserAuthContext';
import dayjs from 'dayjs';
import axios from 'axios';
const BlockedEvent = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const { user, token } = useUserAuth();
    const merchant_id = user.uid;
    const [events, setEvents] = useState([])

    const availabilityFinder = useCallback(async () => {
        if (!merchant_id) return;

        try {
            const { data } = await axios.get(`${base_url}/api/v1/availablity/vendor_id/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEvents(data?.data || []);
        } catch (error) {
            console.error("Error fetching availability:", error);
        }
    }, [base_url, merchant_id, token]);

    useEffect(() => {
        availabilityFinder();
    }, [availabilityFinder]);
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-body'>
                                <h2>Blocked Date</h2>
                                <div className='table-responsive'>
                                    <table className='table  table-bordered  shadow-sm mt-3' cellPadding={5}>
                                        <thead>
                                            <tr>
                                                <th>S. No.</th>
                                                <th>User Name</th>
                                                <th>Booking Starting Date</th>
                                                <th>Booking End Date</th>
                                                <th>Payment Status</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                events?.length > 0 ? (
                                                    events?.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.name}</td>
                                                                <td>{dayjs(item.start_date).format("DD-MM-YYYY")}</td>
                                                                <td>{dayjs(item.end_date).format("DD-MM-YYYY")}</td>
                                                                <td>{item.payment_status}</td>
                                                                <td>{dayjs(item.created_at).format("DD-MM-YYYY")}</td>
                                                            </tr>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={6}>No record found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BlockedEvent